import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { StatesButton, PaddingModes, StatesButtonStates, HoverStyles, Spinner } from "@wix/wix-ui-tpa/cssVars";
import classNames from "classnames";
import { useForcedState, ForcedState } from "../../../../contexts/forced-state-context.js";
import { Widget } from "../../../../ui/widget/widget.js";
import NextButton from "./next-button/next-button.js";
import PreviousButton from "./previous-button/previous-button.js";
import { classes } from "./submit-button-wut.st.css";
import { DATA_HOOKS } from "../../../../constants/data-hooks.js";
const InProgressLoader = ({ submitText }) => {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("div", { "aria-hidden": "true", className: classes.hiddenText, children: submitText }),
    /* @__PURE__ */ jsx(Spinner, { className: classes.spinner })
  ] });
};
const Submit = ({
  onClick,
  disabled,
  submitText,
  hasSteps,
  inProgress
}) => {
  const forcedState = useForcedState();
  const hover = forcedState.includes(ForcedState.SUBMIT_BUTTON_HOVER);
  return /* @__PURE__ */ jsx(
    StatesButton,
    {
      className: classNames(classes.button, {
        [classes.buttonNoSteps]: !hasSteps,
        [classes.buttonWithSteps]: hasSteps,
        [classes.hover]: hover,
        [classes.navigationButtons]: hasSteps,
        [classes.inProgress]: inProgress
      }),
      hoverStyle: HoverStyles.underline,
      upgrade: true,
      wrapContent: true,
      onClick,
      disabled,
      state: inProgress ? StatesButtonStates.IN_PROGRESS : StatesButtonStates.IDLE,
      inProgressContent: /* @__PURE__ */ jsx(InProgressLoader, { submitText }),
      idleContent: submitText,
      paddingMode: PaddingModes.explicitPaddings,
      "data-hook": DATA_HOOKS.SUBMIT_BUTTON
    }
  );
};
const SubmitButtonWUT = ({
  submitText,
  text,
  id,
  previousText,
  nextText,
  FieldLayout,
  hasSteps,
  showPreviousButton,
  showNextButton,
  showSubmitButton,
  onSubmitClick,
  onPreviousClick,
  onNextClick,
  isDisabled,
  isInProgress,
  widgetHtml,
  widgetEnabled
}) => {
  const submitButtonText = submitText || text || "";
  return /* @__PURE__ */ jsx(
    FieldLayout,
    {
      fieldId: id,
      renderLabel: () => null,
      renderInput: () => widgetHtml && widgetEnabled ? /* @__PURE__ */ jsx(
        Widget,
        {
          fieldId: id,
          widgetHtml,
          onChange: () => {
          },
          value: null
        }
      ) : /* @__PURE__ */ jsxs(
        "div",
        {
          className: classNames({
            [classes.navigationContainer]: hasSteps,
            [classes.rowSpacing]: showPreviousButton
          }),
          children: [
            showPreviousButton && /* @__PURE__ */ jsx(
              PreviousButton,
              {
                previousText,
                className: classes.navigationButtons,
                onClick: onPreviousClick
              }
            ),
            showNextButton && /* @__PURE__ */ jsx(
              NextButton,
              {
                nextText,
                className: classes.navigationButtons,
                onClick: onNextClick
              }
            ),
            showSubmitButton && /* @__PURE__ */ jsx(
              Submit,
              {
                onClick: () => onSubmitClick?.(),
                disabled: isDisabled,
                submitText: submitButtonText,
                hasSteps,
                inProgress: isInProgress
              }
            )
          ]
        }
      ),
      renderDescription: () => null
    }
  );
};
export {
  SubmitButtonWUT
};
//# sourceMappingURL=submit-button-wut.js.map
